/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-cycle */
/* eslint-disable no-useless-constructor */
/* eslint-disable class-methods-use-this */
import { user } from '../../../../api';
import { hashString } from '../../../../helpers/hash';
import { pipeline } from '..';
import { LVTMetricCheckoutAnalysisStep } from '../../types';
import { FlowPrimitives } from './primitives';

class FlowPipeline {
  private idempotencyRegister = {} as Record<
    LVTMetricCheckoutAnalysisStep,
    boolean
  >;

  constructor(public primitives: FlowPrimitives) {}

  async start(options: { from: LVTMetricCheckoutAnalysisStep }): Promise<void> {
    // TODO(dark-launch): remove 'if' after metrics dark launch strategies would be over
    if (window.location.origin !== 'https://stage.rbo.org.uk') return;

    if (this.idempotencyRegister[options.from]) return;

    const {
      data: {
        attributes: { sessionKey: webSessionKey },
      },
    } = await user.get({});
    const sessionId = await hashString(webSessionKey);
    const timestampEntry = Date.now();

    pipeline.storage
      .setSessionStorageItem('sessionId', sessionId)
      .setSessionStorageItem('entryStepName', options.from)
      .setSessionStorageItem(options.from, timestampEntry.toString());

    pipeline.storage
      .setLocalStorageItem('stepName', options.from)
      .setLocalStorageItem('startCheckoutTime', timestampEntry.toString())
      .removeLocalStorageItem('closedWebsiteAt');

    this.primitives.addCheckoutStepEvent(
      options.from,
      { sessionId, timestampEntry },
      pipeline.storage.entry(options.from)
    );
    this.idempotencyRegister[options.from] = true;
  }

  step(options: {
    to: LVTMetricCheckoutAnalysisStep;

    /** Defaults to the previous step in `localStorage.stepName` */
    from?: LVTMetricCheckoutAnalysisStep;

    /** Defaults to `true` */
    saveToStorage?: boolean;

    /** Defaults to `{}` */
    additionalData?: object;

    additionalBehaviour?: () => void;
  }): this {
    // TODO(dark-launch): remove 'if' after metrics dark launch strategies would be over
    if (window.location.origin !== 'https://stage.rbo.org.uk') return this;

    const saveToStorage = options.saveToStorage ?? true;
    const additionalData = options.additionalData ?? {};
    const sessionId = pipeline.storage.getSessionStorageItem('sessionId');
    if (!sessionId) {
      console.warn('Metrics: sessionId was not found');
      return this;
    }

    const from =
      options.from ??
      (pipeline.storage.getLocalStorageItem('stepName') as
        | LVTMetricCheckoutAnalysisStep
        | undefined);

    if (!from) {
      console.warn('Metrics: stepName was not found');
      return this;
    }

    this.primitives.exitPreviousEvent(sessionId, from, { saveToStorage });
    this.primitives.enterNextEvent(
      sessionId,
      options.to,
      { saveToStorage },
      additionalData
    );

    if (options.additionalBehaviour) options.additionalBehaviour();

    return this;
  }

  withStepTransition<T extends (...args: any[]) => any>(
    cb: T,
    options: Parameters<typeof this['step']>[0]
  ): T {
    return ((...args) => {
      this.step(options);
      return cb(...args);
    }) as T;
  }
}

const primitives = new FlowPrimitives();
export const flowPipeline = new FlowPipeline(primitives);
